import React, { Component } from 'react';
import { LinkBox } from '..';
import './style.scss';
import { HashLink as Link } from 'react-router-hash-link';

import { connect } from 'react-redux';
import * as AuthActions from '../../actions/AuthActions';

class LinkList extends Component {

  handlePosition = () => {
    console.log('Aqui')

  }


  render(){
    var filiadas = [
      'TV 5','TV Macapa','TV Nordeste TV','TV Capixaba','TV Goiania','TV Caxias',
      'TV Vitoria Regia','TV Interativa','TV RBA Belem','TV RBA Maraba','TV RBA Santarem',
      'TV Manaira','TV Taroba Cascavel', 'TV Maringa','TV Taroba Londrina','TV Tribuna',
      'TV Meridional','TV Band Roraima','TV Barriga Verde','TV Clube','TVB Band Litoral',
      'TV Sil','TV Amazonia', 'TV Integracao', 'TV Regional'];

    var logado = this.props.loggedUser.profile.name;
    //var login = this.props.loggedUser.profile.sub;
    //alert(login)
    //var logado = 'tvtarobalondrina';

    var teamFiliada = filiadas.indexOf(logado) > -1;

      if(teamFiliada){
          return(
            <div className="link-list">
        <div className="container">
          <div className="row">

            <LinkBox
              title="Informações Executivas"
              description="Informações Executivas"
              icon="fas fa-user-tie"
              link="https://gestor.bandeirantes.digital/Comercial"
            />
            <LinkBox
              title="Pedido de Inserção"
              description="Pedido de Inserção"
              icon="fas fa-plus-circle"
              link="https://app.adsim.co/"
            />
            <LinkBox
              title="Planos Comerciais"
              description="Download"
              icon="fas fa-download"
              link="/planos-comerciais"
              internal={true}
              selected={this.props.commercialPlan}
            />
             <LinkBox
              title="Patrocínio"
              description="Relação de Patrocinio"
              icon="far fa-handshake"
              link="https://gestor.bandeirantes.digital/rp/patrocinio"
            />


          </div>
        </div>
      </div>
          )
      }else{
        return(
          <div className="link-list">

          <div className="container">
            <div className="row">


              <LinkBox
                title="Pré-venda"
                description="Pré-venda"
                icon="fas fa-calendar-check"
                link="/negociacoes"
                internal={true}
                selected={this.props.selected}
                onClick={this.handlePosition}

              />
              <LinkBox
                title="Disponibilidade"
                description="Disponibilidade"
                icon="fas fa-search-dollar"
                link="https://emidia.band.com.br/disponibilidade"
              />
              <LinkBox
                title="Informações de Mercado"
                description="Kantar Ibope"
                icon="fab fa-hubspot"
                link="http://redeband.pilot.hubbe.co/"
              />
              <LinkBox
                title="Informações Executivas"
                description="Informações Executivas"
                icon="fas fa-user-tie"
                link="https://gestor.bandeirantes.digital/Comercial"
              />
              <LinkBox
                title="Pedido de Inserção"
                description="Pedido de Inserção"
                icon="fas fa-plus-circle"
                link="https://app.adsim.co/"
              />
              <LinkBox
                title="Planos Comerciais"
                description="Download"
                icon="fas fa-download"
                link="/planos-comerciais"
                internal={true}
                selected={this.props.commercialPlan}
              />
               <LinkBox
                title="Patrocínio"
                description="Relação de Patrocinio"
                icon="far fa-handshake"
                link="https://gestor.bandeirantes.digital/patrocinio"
              />

             {/*    <LinkBox
                title="Documentos"
                description="Compartilhamento de Documentos"
                icon="fas fa-share-square"
                link="https://band.sharepoint.com/sites/bandcomercialtvdoc"
              /> */}

              <LinkBox
              title="Gestão de Documentos"
              description="Documentos, Políticas, Normas e Procedimentos"
              icon="far fa-file-pdf"
              link="https://band.sharepoint.com/sites/fiquepordentro"
              />

              <LinkBox
              title="MidiaPlan"
              description="Carregue a planilha aqui"
              icon="far fa-file-excel"
              link="https://gestor.bandeirantes.digital/midiaplan"
              />

            <LinkBox
              title="Briefing"
              description="Planejamento Comercial"
              icon="fas fa-tasks"
              link=" https://forms.office.com/Pages/ResponsePage.aspx?id=_GsWd5d1YU-0uap-7BvqazFKvXgtTWRLlF9cDpeLOl1UQU43VjQ5VkxKVkRFQUdaS1lZTDc5UzBGSS4u"
            />

            <LinkBox
              title="Audiência Social"
              description="Audiência Social"
              icon="fa fa-television"
              link="https://vibrabi.band.com.br/ReportsBI/powerbi/Vibra/Audiencia/Digital"
            />

            <LinkBox
              title="Audiência de Faturamento"
              description="Audiência de Faturamento"
              icon="fas fa-chart-line"
              link="https://vibrabi.band.com.br/ReportsBI/powerbi/Vibra/Comercial/Comercial_TV_Aberta"
            />

            </div>
          </div>


        </div>



        )
      }

    }

}

const mapStateToProps = ({ auth }) => {
  return {
    ...auth
  };
};

export default connect(
  mapStateToProps,
  { ...AuthActions }
)(LinkList);



